import { useNavigate } from 'react-router-dom'
import { Paywall } from '../components/Paywall'

export default function PaywallPage() {
  const navigate = useNavigate()

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-slate-900 to-slate-950">
      <Paywall isOpen onClose={() => navigate(-1)} />
    </div>
  )
}
